<div class="ar-limit-diloag add-payment p-0">
  <div class="dialog-header ui-g-12 p-zero">
    <div class="ar-limit-diloag-header font-700 font-18">Update Limit Allowed</div>
    <i class="fal fa-times close-icon pointer dialog-close" (click)="closeDialog(false, 'cancel')"></i>
  </div>

  <div class="dialog-body ar-limit-content font-12">
    <div class="ui-g-12 pt-2 p-3 font-14 font-400">Update the limit allowed for this account.</div>

    <div class="ui-g-12 pt-0 px-3">
      <div class="p-2 change-color-gray limit-input-wrapper">
        <p class="mb-0">Current Limit</p>
        <div *ngIf="!isCurrentUnlimted">
          <app-input theme="light" id="available limit" placeholder="" readOnly="true"
            [value]="data.customerARLimit | currency : usd"></app-input>
        </div>
        <div *ngIf="isCurrentUnlimted">
          Unlimited
        </div>
      </div>
    </div>

    <div class="ui-g-12 pt-2 px-3">
      <div class="p-2 limit-input-wrapper">
        <p class="mb-0">New Limit</p>
        <div class="calculator-field">
          <app-input id="new-limit" [selectTextOnFocus]="true" [hasHoverBorderBottom]="false"
            [allowDecimal]="focus?.newLimit ? true : false" theme="light" placeholder="Enter the value"
            [isInvalid]="limitErrorMsg" [errorMessage]="limitErrorMsg"
            [autoFocus]="true" (appFocus)="handleFocus()"
            (appChange)="handleChange($event)"
            [value]="focus.newLimit ? amount : (amount | currency : 'USD')">
          </app-input>
        </div>
      </div>
    </div>
  </div>

  <div class="ui-g-12 p-zero dialog-footer text-right">
    <button id="change-dialog-btn-cancel" (click)="closeDialog(false, 'cancel')"
      class="btn btn-white btn-border pointer btn-submit mr-2">Cancel</button>
    <button id="change-dialog-btn-submit" (click)="closeDialog(true, 'cancel')"
      class="btn btn-primary pointer btn-submit">Update</button>
  </div>
</div>
